import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const TitleSection = styled.div`
  background-color: ${props => (props.backgroundColor ? props.backgroundColor : 'rgb(255, 219, 211)')};
  box-sizing: border-box;
  padding: 10px;
  text-align: center;
`;

export const LegendSection = styled.div`
  background-color: ${props => (props.backgroundColor ? props.backgroundColor : 'rgb(255, 219, 211)')};
  width: 50px;
  height: 50px;
  position: relative;
`;

export const RectangleWhite = styled.div`
  position: absolute;
  width: 15px;
  height: 15px;
  background-color: white;
`;
